/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import classNames from 'classnames';
import Icon from 'components/_particles/icon/react/Icon';

export type MediaButtonType = {
  icon?: string,
  text?: string,
  className?: string,
};

const MediaButton = ({
  icon,
  text,
  className,
}: MediaButtonType): React$MixedElement => {
  return (
    <div className={classNames('media-button', className)}>
      {icon && <Icon icon={icon} className="media-button__icon" />}
      <span className="media-button__text">{text}</span>
    </div>
  );
};

export default MediaButton;
